import { NavLink } from "react-router-dom";
import { FiChevronRight, FiLogOut, FiPlus } from "react-icons/fi";
import useAuthStore from "store/authStore";
import { accountSections } from "./accountSections";

const AccountNavigation = ({
	profile,
	isLoading,
	isLoggingOut,
	canAddSeats,
	onNavigate,
	onLogout,
	onAddSeats,
	onDelete,
}) => {
	const { hasRoles, hasPermissions } = useAuthStore();
	const sections = accountSections.filter(
		(item) =>
			!item.hidden &&
			(!item.role || hasRoles([item.role])) &&
			(!item.permission || hasPermissions([item.permission])),
	);
	const groups = [...new Set(sections.map((item) => item.group))];
	const name =
		[profile?.first_name, profile?.last_name].filter(Boolean).join(" ") || "Your account";
	const initials =
		[profile?.first_name?.[0], profile?.last_name?.[0]].filter(Boolean).join("") || "A";
	return (
		<div className="account-navigation">
			<div className="account-identity">
				<div className="account-avatar" aria-hidden="true">
					{profile?.avatar ? <img src={profile.avatar} alt="" /> : initials}
				</div>
				<div className="account-identity-text">
					<p className="account-identity-name">{isLoading ? "Loading your profile…" : name}</p>
					<p className="account-identity-email" title={profile?.email}>
						{profile?.email || "Make yourself at home"}
					</p>
				</div>
			</div>
			<nav aria-label="Account navigation">
				{groups.map((group) => (
					<div className="account-nav-group" key={group}>
						<p className="account-nav-label">{group}</p>
						{sections
							.filter((item) => item.group === group)
							.map(({ path, label, icon: Icon }) => (
								<NavLink
									exact
									key={path}
									to={path}
									className="account-nav-link"
									activeClassName="is-active"
									onClick={onNavigate}
								>
									<Icon aria-hidden="true" />
									<span>{label}</span>
									<FiChevronRight className="account-nav-arrow" aria-hidden="true" />
								</NavLink>
							))}
					</div>
				))}
			</nav>
			{canAddSeats && (
				<button type="button" className="account-button account-add-seats" onClick={onAddSeats}>
					<FiPlus aria-hidden="true" /> Add seats
				</button>
			)}
			<div className="account-nav-footer">
				<button type="button" className="account-logout" disabled={isLoggingOut} onClick={onLogout}>
					<FiLogOut aria-hidden="true" />
					{isLoggingOut ? "Signing out…" : "Sign out"}
				</button>
				<button type="button" className="account-delete-link" onClick={onDelete}>
					Delete account
				</button>
			</div>
		</div>
	);
};

export default AccountNavigation;
